import { Card, CardContent } from '@skylabs-digital/backoffice-kit';
import { TimeSeriesChart } from '@skylabs-digital/backoffice-kit/charts';
import type { WebhooksSeries } from '../../schemas/webhook.schema';

function timeFormatter(window: WebhooksSeries['window'] | undefined) {
  return (t: string | number) => {
    const d = new Date(t);
    if (window === '7d') return d.toLocaleDateString([], { weekday: 'short', hour: '2-digit' });
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };
}

export function WebhookChart({ series }: { series: WebhooksSeries | null }) {
  return (
    <Card>
      <CardContent className="pt-6">
        <TimeSeriesChart
          title="Delivered vs failed"
          data={series?.points ?? []}
          series={[
            { key: 'delivered', label: 'Delivered', type: 'bar' },
            { key: 'failed', label: 'Failed', type: 'bar', color: 'hsl(var(--destructive))' },
          ]}
          height={220}
          loading={series === null}
          formatTime={timeFormatter(series?.window)}
          emptyMessage="No deliveries in this window"
        />
      </CardContent>
    </Card>
  );
}
